import Link from 'next/link';

import ActivityTypes from '@/constants/ActivityTypes';
import ActivityTypeIcon from '@/shared/ActivityTypeIcon/ActivityTypeIcon';
import { pxToVw } from '@/modules/styled/cssUnits';

import {
  StyledActivityIconCircle,
  StyledActivityTypesList,
} from './ActivityTypesList.styled';

export default function ActivityTypesList() {
  const activityTypes = ActivityTypes.withLabels;

  return (
    <StyledActivityTypesList className="activities-list">
      <Link href={'/themes'} className="activity-type" passHref>
        <StyledActivityIconCircle themes type={'themes'}>
          <ActivityTypeIcon type={'themes'} color={'white'} size={pxToVw(24)} />
        </StyledActivityIconCircle>
        <span className="activity-type-name">Themes</span>
      </Link>
      {activityTypes.map((activityType) => {
        return (
          <Link
            href={`/${ActivityTypes.toSlug[activityType.value]}`}
            key={activityType.value}
            className="activity-type"
            passHref
          >
            <StyledActivityIconCircle type={activityType.value}>
              <ActivityTypeIcon
                type={activityType.value}
                color={'white'}
                size={pxToVw(24)}
              />
            </StyledActivityIconCircle>
            <div className="activity-type-name">{activityType.label}</div>
          </Link>
        );
      })}
      {/* {showMore && (
        <Link href={'/themes'}>
          <a className="activity-type">
            <StyledActivityIconCircle type={'more'}>
              <PlusOutlined className="more" />
            </StyledActivityIconCircle>
            <div className="activity-type-name">Much more!</div>
          </a>
        </Link>
      )} */}
    </StyledActivityTypesList>
  );
}
